import { apiSend, getRoute } from "@services/axios";
import Swal from "sweetalert2";
import { isUddi } from "@global/actions";
import { error, success } from "@global/actions";
export const updtaUserithValidation = async (formData, extraParam) => {
  const res = await apiSend(extraParam.route, "post", formData);

  extraParam.setLoading(false);
  switch (res?.data?.request?.code) {
    default:
      error(res?.data?.result?.message);

      break;
    case 200:
      await Swal.fire({
        title: extraParam.t(extraParam.title),
        input: "text",
        inputLabel: res?.data?.result?.message,
        showCancelButton: true,
        confirmButtonText: extraParam.t("send"),
        cancelButtonText: extraParam.t("cancel"),
        showLoaderOnConfirm: true,

        preConfirm: async (value) => {
          if (isUddi(value) === false) {
            return Swal.showValidationMessage(extraParam.t("code_not_valid"));
          }
          const response = await apiSend(
            [extraParam.route, value, "validate"].join("/"),
            "get"
          );

          if (response?.data?.request?.code !== 200) {
            return Swal.showValidationMessage(extraParam.t("not_update"));
          }

          success(response?.data?.result?.message);
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
      break;
  }
};

export const generatePassword = async (id, setLoading) => {
  setLoading(true);
  const response = await apiSend(
    [getRoute("USER_RETRIEVE"), id, "generate/password"].join("/"),
    "get"
  );
  if (response?.data?.request?.code === 200) {
    success(response?.data?.result?.message);
  } else {
    error(response?.data?.result?.message);
  }
  setLoading(false);
};

export const saveChangeStatus = async (id, status) => {
  var bool = true;

  const payload = {
    dataUser: [id],
    status: status,
  };
  try {
    const res = await apiSend(
      [getRoute("USER_RETRIEVE"), "activate"].join("/"),
      "post",
      payload
    );

    if (res?.data?.request?.code === 200) {
      success(res?.data?.result?.message);
    } else {
      error(res?.data?.result?.message, "error");
      bool = false;
    }
    return bool;
  } catch (error) {}
};
